module.exports = __webpack_public_path__ + "img/garage.be5030ca.webp";